
import IconButton from '../../../icon-button';
import Gutter from '../../../gutter';
import { IconType } from '../../../icon/enums';
import { StyleColorSchemeType, StylePositionType, StyleSizeType } from '../../../../styles/enums';
import { GridSizeStylesProps, GridSizeStylesMethods } from '../../mixins/grid-size-styles';
import {
  GridColumnCommonOptionsType,
  GridSortType,
  GridHeaderPropsEventType,
  GridSortFnType,
} from '../../enums';
import GridSortingFnsFactory from '../../sorting/factories/GridSortingFnsFactory';
import GridStickyCell from '../../mixins/grid-sticky-cell';

export default {
  name: 'GridHeader',
  components: { Gutter, IconButton },
  mixins: [GridSizeStylesProps, GridSizeStylesMethods, GridStickyCell],
  props: {
    columns: {
      default: () => [],
      type: Array,
    },
    stickyPositions: {
      default: () => [],
      type: Array,
    },
  },
  data() {
    return {
      sortType: null,
      sortByColumn: null,
      IconType,
      StyleColorSchemeType,
      StylePositionType,
      StyleSizeType,
    };
  },
  computed: {
    cellClassNames() {
      return this.getClassNamesBuilderWithSizeClassNames('grid-header-row-cell')
        .build();
    },
  },
  methods: {
    getIconType(column) {
      if (this.sortByColumn !== column.key) {
        return IconType.Sort;
      }

      switch (this.sortType) {
        case GridSortType.Asc:
          return IconType.ChevronUp;
        case GridSortType.Desc:
          return IconType.ChevronDown;
        default:
          return IconType.Sort;
      }
    },
    getNextSortType(sortType) {
      switch (sortType) {
        case GridSortType.Asc:
          return null;
        case GridSortType.Desc:
          return GridSortType.Asc;
        default:
          return GridSortType.Desc;
      }
    },
    getIsSortable(column) {
      if (!column.options) {
        return false;
      }

      return column.options[GridColumnCommonOptionsType.Sortable];
    },
    getSortFnsInstance(option) {
      if (option.type === GridSortFnType.Custom) {
        return option.sortFns;
      }

      return GridSortingFnsFactory.getSortFnsByType(option.type);
    },
    handleSortClick(column) {
      this.sortByColumn = column.key;
      this.sortType = this.getNextSortType(this.sortType);

      const sortableOptions = column.options[GridColumnCommonOptionsType.Sortable];
      const sortFns = this.getSortFnsInstance(sortableOptions);

      this.$emit(GridHeaderPropsEventType.Sort, {
        columnKey: this.sortByColumn,
        sortType: this.sortType,
        sortFns,
      });
    },
  },
};
